module.exports = __webpack_public_path__ + "static/img/cont50 (3).ea4de6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont50 (3).jpg
// module id = 1ORt
// module chunks = 0